<template>
    <div class="model-sign-dialog">
        <div class="sign-cont">
            <div class="sign-title">
                <div class="close">
                    <img src="http://img.xiaoqijiankang.com/images/closed.png"/>
                </div>
            </div>
            <div class="sign-middle">
              <img src="http://img.xiaoqijiankang.com/images/signs.jpg" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SignsDialog'
}
</script>
<style lang="scss" scoped>
.model-sign-dialog{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.7);
    .sign-cont{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 700px;
        height: 900px;
        overflow-y: auto;
        background-color: #fff;
        .sign-title{
            display: flex;
            justify-content: flex-end;
            .close{
               width: 60px;
               height: 60px;
               img{
                   width: 100%;
               }
            }
        }
        .sign-middle{
            width: 700px;
            height: 900px;
            overflow-y: auto;
            background-color: #fff;
            >img{
            width: 100%;
         }
        }
    }
}
</style>